export default "__VITE_ASSET__I4LSQXkH__"